var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceGlassdoor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.9991C22 19.7612 19.7612 22 17.0001 22H6.99995C4.23793 22 2 19.7612 2 16.9991V7.00008C2 4.238 4.23793 2 6.99995 2H17.0001C19.7612 2 22 4.238 22 7.00008L22 16.9991Z",
    fill: "#1DAC4B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2634_41857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41422 17.9997H14.5861C15.041 17.9997 15.4772 17.8191 15.7988 17.4974C16.1204 17.1758 16.3011 16.7396 16.3011 16.2847V9.16504H14.5861V16.2847H7.69922C7.69922 16.7396 7.87991 17.1758 8.20153 17.4974C8.52316 17.8191 8.95937 17.9997 9.41422 17.9997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5861 6H9.41422C8.95937 6 8.52316 6.18069 8.20153 6.50231C7.87991 6.82394 7.69922 7.26015 7.69922 7.715V14.835H9.41422V7.715H16.3011C16.3011 7.26015 16.1204 6.82394 15.7988 6.50231C15.4772 6.18069 15.041 6 14.5861 6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2634_41857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceGlassdoor);
export default __webpack_public_path__ + "static/media/source-glassdoor.f4e191fd24b4908d69eadb2e31bfc4fe.svg";
export { ForwardRef as ReactComponent };